import { BaseControl } from '.';

/**
 * @typedef {object} SelectOption
 * @property {string} value - Value of the option
 * @property {string} label - Display label for the option
 */

/**
 * @typedef {object} FontFamilyControlOptions
 * @property {SelectOption[]} [fonts] - Available fonts. If not provided, a default set of fonts will be used.
 */

/**
 * @extends {BaseControl<string, FontFamilyControlOptions>}
 */
export class FontFamilyControl extends BaseControl {

    /** @type {BaseControl<string>['render']} */
    render(value, onChange) {
        return (
            <div className="font-control">
                <select value={value} onChange={e => onChange(e.target.value)}>
                    {this.options.fonts ? (
                        this.options.fonts.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))
                    ) : (
                         <>
                            <option value="Arial">Arial</option>
                            <option value="Helvetica">Helvetica</option>
                            <option value="Times New Roman">Times New Roman</option>
                            <option value="Courier New">Courier New</option>
                            <option value="Verdana">Verdana</option>
                            <option value="Roboto">Roboto</option>
                            <option value="Poppins">Poppins</option>
                         </>
                    )}
                </select>
            </div>
        );
    }
}
